<template>
  <v-row>
    <v-col md="8" offset-md="2" xl="6" offset-xl="3">
      <BaseBlock title="Reset état candidature étudiant">
        <Autocomplete
          v-model="etudiant"
          title="Recherche de l'étudiant"
          subtitle="La recherche s'effectue à partir des premières lettres du nom. Au moins 2 lettres sont requises."
          source="etudiants"
        ></Autocomplete>

        <v-row v-if="candidatures.length > 0">
          <v-col>
            <v-expansion-panels>
              <v-expansion-panel
                v-for="(item, index) in candidatures"
                :key="index"
              >
                <v-expansion-panel-header>
                  <v-row>
                    <v-col cols="6">
                      <span class="primary--text">{{
                        item.libelleFormation
                      }}</span>
                    </v-col>
                    <v-col cols="4">{{ item.etatDemande.libelle }}</v-col>
                    <v-col cols="2">
                      <FormDialogResetCandidature
                        :candidature="item"
                        @majCandidature="refreshCandidature(index)"
                        :key="keyDialogReset"
                      />
                    </v-col>
                  </v-row>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <HistoriqueCandidature
                    :idCandidature="item.id"
                    :key="keyHistorique"
                  ></HistoriqueCandidature>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-col>
        </v-row>
      </BaseBlock>
    </v-col>
  </v-row>
</template>
<script>
import Autocomplete from "@/components/Autocomplete";
import BaseBlock from "@/components/base/BaseBlock";
import ApiCandidatureRepository from "@/repositories/ApiCandidatureRepository";
import { EtatDemande } from "@/mixins/EtatDemande.js";
import HistoriqueCandidature from "@/components//HistoriqueCandidature.vue";
import FormDialogResetCandidature from "@/components/FormDialogResetCandidature";

export default {
  name: "ResetEtatCandidature",
  components: {
    Autocomplete,
    BaseBlock,
    HistoriqueCandidature,
    FormDialogResetCandidature
  },
  mixins: [EtatDemande],
  data() {
    return {
      headers: [
        {
          text: "Formation",
          align: "left",
          sortable: true,
          value: "libelleFormation"
        },
        {
          text: "Etat de la demande",
          align: "center",
          sortable: true,
          value: "etatDemande"
        }
      ],
      etudiant: null,
      candidatures: [],
      candidature: {},
      keyHistorique: 0,
      keyDialogReset: 0
    };
  },
  watch: {
    etudiant() {
      if (this.etudiant) {
        this.getCandidaturesEtudiant();
      } else {
        this.candidatures = [];
      }
    }
  },
  methods: {
    async getCandidaturesEtudiant() {
      try {
        const candidatures = await ApiCandidatureRepository.getCandidaturesEtudiantPourGestion(
          this.etudiant.id
        );
        this.candidatures = candidatures.sort(function(a, b) {
          return a.libelleFormation
            .toLowerCase()
            .localeCompare(b.libelleFormation.toLowerCase());
        });
      } catch (error) {
        this.$toast.error(error.response.data.messages[0]);
      }
    },
    async getCandidatureEtudiant(idCandidature) {
      try {
        const candidature = await ApiCandidatureRepository.getCandidatureEtudiantPourGestion(
          this.etudiant.id,
          idCandidature
        );
        this.candidature = candidature;
      } catch (error) {
        this.$toast.error(error.response.data.messages[0]);
      }
    },
    async refreshCandidature(index) {
      await this.getCandidatureEtudiant(this.candidatures[index].id);
      this.$set(this.candidatures, index, this.candidature);
      this.keyHistorique += 1;
      this.keyDialogReset += 1;
    }
  }
};
</script>
